import * as clearview from "../../../../../components/@Clearview"

const Formatters = {
	linesToCommas: it => it?.toString().replace(/\n|(,\n)/gm, ", "),
	upperCase: it => it?.toString().toUpperCase(),
	shortDate: it => clearview.FormatDate(it, "DD/MM/YY", it),
	longDate: it => clearview.FormatDate(it, "DD MMMM YYYY", it),
	currency: it =>
		parseFloat(it).toLocaleString("en-GB", {
			useGrouping: true,
			minimumFractionDigits: 2,
		}),
	currencyPence: it =>
		(parseFloat(it) / 100.0).toLocaleString("en-GB", {
			useGrouping: true,
			minimumFractionDigits: 2,
		}),
	accountancyPence: it => {
		var absValue = Math.abs(it)
		var absString = Formatters.currencyPence(absValue)

		return it < 0 ? `(${absString})` : absString
	},
	undefined: it => it,
}

export default Formatters
